import * as geo_loader from 'geo-loader';
import { State } from './definition.state';
import { globalMapObject } from '../module';
import ol from 'openlayers';
import * as mapUtil from '../map/map.util';
import { providerProduct } from '../providers/provider.product';
import { providerSearch, PostcodeSearchResponse } from '../providers/provider.search';
// import { computeAreaFromCoordinates } from '../map/map.util';
import { transformer } from '../map/geom.transform';
import { cfg } from '../config';

const USE_SELECT_BY_RECT: boolean = false;

declare type InputParameterTypeLocal = undefined;
declare type PassOverParameterTypeLocal = { area: number, coordinates: number[][] };

export class StateSelectArea extends State<InputParameterTypeLocal, PassOverParameterTypeLocal> {

    private mapSource: ol.source.Vector = new ol.source.Vector();
    private mapLayer: ol.layer.Vector = new ol.layer.Vector({ source: this.mapSource });

    private drawRectangleInteraction: ol.interaction.Draw;
    private drawPolygonInteraction: ol.interaction.Draw;


    private lastDrawRectangleGeomAreaValue?: number;

    private _post_code_input: HTMLInputElement = document.createElement("input");

    // override
    constructor(node_application_container: HTMLDivElement) {
        super(node_application_container);
        this.id = 'select-area';
        this.initModes();

        this.drawRectangleInteraction = mapUtil.drawRectangleInteraction(this.mapSource, this.styleFunction.bind(this));
        this.drawPolygonInteraction = mapUtil.drawPolygonInteraction(this.mapSource, this.styleFunction.bind(this));

        this.initMap();
        this.buildDom(node_application_container);
    }


    // override
    get passOverPrameters() {
        this._passOverPrameters = { area: this.selectArea, coordinates: this.selectCoordinates };
        return super.passOverPrameters;
    }

    // post activate function. It is used (via override) to do something after activate (eg change mode when no default mode is needed)
    // notice that on activate default mode is used
    // override
    protected onActivated() {
        this.customToggleDomItem('select-next', false);
        this.customToggleDomItem('select-next-disabled', true);
        this.lastDrawRectangleGeomAreaValue = undefined;
    }


    // post activate function. It is used (via override) to do something after activate (eg change mode when no default mode is needed)
    // notice that on activate default mode is used
    protected onDisactivated() {
        globalMapObject.map.removeInteraction(this.drawRectangleInteraction);
        globalMapObject.map.removeInteraction(this.drawPolygonInteraction);
        globalMapObject.interactions.dragPan.setActive(true);
        this.lastDrawRectangleGeomAreaValue = undefined;
    }

    private initModes() {
        this.mode('default').attachAction(() => {
            this.mapSource.clear();
            globalMapObject.map.removeInteraction(this.drawRectangleInteraction);
            globalMapObject.map.removeInteraction(this.drawPolygonInteraction);
            globalMapObject.interactions.dragPan.setActive(true);
        });
        this.addMode('select-rectangle').attachAction(() => {
            globalMapObject.map.addInteraction(this.drawRectangleInteraction);
            this.customToggleDomItem('client-map-selector-proceed', false);
            this.customToggleDomItem('select-area-notificator-content', false);
            this.customToggleDomItem('select-next', false);
            this.customToggleDomItem('select-next-disabled', true);
            // globalMapObject.interactions.dragPan.setActive(false);
        });
        this.addMode('select-polygon').attachAction(() => {
            globalMapObject.map.addInteraction(this.drawPolygonInteraction);
            this.customToggleDomItem('client-map-selector-proceed', false);
            this.customToggleDomItem('select-area-notificator-content', false);
            this.customToggleDomItem('select-next', false);
            this.customToggleDomItem('select-next-disabled', true);
        });
        this.addMode('select-file').attachAction(() => {
            this.mapSource.clear();
            this.customToggleDomItem('client-map-selector-proceed', false);
            this.customToggleDomItem('select-area-notificator-content', false);
            this.customToggleDomItem('select-next', false);
            this.customToggleDomItem('select-next-disabled', true);
        });
        this.addMode('file-selected').attachAction(() => {
            console.log(this.selectArea)
            setTimeout(() => {
                console.log(this.selectArea)
                this.customToggleDomItem('select-area-notificator-content', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-next', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-next-disabled', !(this.selectArea < providerProduct.max_area));
                this.lastDrawRectangleGeomAreaValue = undefined;
            }, 500);
            // this.mapSource.clear();
            // this.customToggleDomItem('client-map-selector-proceed', false);
            // this.customToggleDomItem('select-next', false);
            // this.customToggleDomItem('select-next-disabled', true);
        });
    }

    private initMap() {

        globalMapObject.map.addLayer(this.mapLayer);

        this.drawRectangleInteraction.on('drawstart', (() => { this.lastDrawRectangleGeomAreaValue = undefined; this.mapSource.clear(); }));
        this.drawPolygonInteraction.on('drawstart', (() => { this.lastDrawRectangleGeomAreaValue = undefined; this.mapSource.clear(); }));

        this.drawRectangleInteraction.on('drawend', (() => {
            setTimeout(() => {
                // this.customToggleDomItem('client-map-selector-proceed', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-area-notificator-content', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-next', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-next-disabled', !(this.selectArea < providerProduct.max_area));
                this.lastDrawRectangleGeomAreaValue = undefined;
            }, 500);
        }));
        this.drawPolygonInteraction.on('drawend', (() => {
            console.log('drawPolygonInteraction drawend');
            setTimeout(() => {
                this.customToggleDomItem('select-area-notificator-content', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-next', this.selectArea < providerProduct.max_area);
                this.customToggleDomItem('select-next-disabled', !(this.selectArea < providerProduct.max_area));
                this.lastDrawRectangleGeomAreaValue = undefined;
            }, 500);
        }));
    }




    private buildDom(parent_container: HTMLDivElement) {

        {
            let info_curtain = document.createElement("div");
            info_curtain.className = 'info-curtain';
            parent_container.appendChild(info_curtain);

            let arrow_image = document.createElement("img");
            arrow_image.id = 'arrow-image-postcode';
            arrow_image.src = cfg.apiUrlBase + "/static/" + cfg.name + ".arrow_left.png",
                info_curtain.appendChild(arrow_image);


            let select_postcode_text = document.createElement("div");
            select_postcode_text.className = 'text';
            select_postcode_text.style.top = '14px'
            select_postcode_text.style.left = '240px'
            select_postcode_text.innerHTML = 'To begin enter the postcode for your area of interest here and click return.'
            info_curtain.appendChild(select_postcode_text);



            // let arrow_image_select = document.createElement("img");
            // arrow_image_select.id = 'arrow-image-select';
            // arrow_image_select.src = cfg.apiUrlBase + "/static/" + cfg.name + ".arrow_left.png",
            //     info_curtain.appendChild(arrow_image_select);


            let select_area_text = document.createElement("div");
            select_area_text.className = 'text';
            select_area_text.style.top = '200px'
            select_area_text.style.left = '65px'
            select_area_text.style.width = '400px'
            select_area_text.innerHTML = `Please plot your field/area boundaries as accurately as possible so that your report(s) and viticulture suitability assessment(s) is/are restricted only to the areas in which you are interested.
            <br><br>
            To maximise area selection accuracy you can either upload a KML file or zoom in to capture a more precise definition of the area`;
            info_curtain.appendChild(select_area_text);


            let click_anywhere_to_start = document.createElement("div");
            click_anywhere_to_start.id = 'click-anywhere-to-start';
            click_anywhere_to_start.innerHTML = 'Click anywhere to start'
            info_curtain.appendChild(click_anywhere_to_start);


            info_curtain.addEventListener('click', () => {
                info_curtain.style.display = 'none';
            })
        }





        this._post_code_input = document.createElement("input");
        this._post_code_input.id = 'client-search-keyword';
        this._post_code_input.className = 'map-widget';
        this._post_code_input.placeholder = 'post-code';
        this._post_code_input.title = 'Enter postcode here to refine search area';
        this._post_code_input.addEventListener("keyup", (ev: KeyboardEvent) => {
            this._post_code_input.value = this._post_code_input.value.toUpperCase();
            if (ev.keyCode === 13) {
                let searchString = this._post_code_input.value;
                providerSearch.postcode(searchString).then((c: PostcodeSearchResponse) => {
                    if (c.features[0] !== undefined) {
                        let center: [number, number] = c.features[0].geom.coordinates;
                        let x = [[center[0] - 0.01, center[1] - 0.01], [center[0] + 0.01, center[1] + 0.01]].map(v => ol.proj.transform(<[number, number]>v, 'EPSG:4326', 'EPSG:3857'));

                        globalMapObject.zoomTo([x[0][0], x[0][1], x[1][0], x[1][1]], {})
                        globalMapObject.flash_point(center, 2000);
                    }
                })
            }
        });
        parent_container.appendChild(this._post_code_input);


        let post_code_input_button = document.createElement("div");
        post_code_input_button.id = 'client-search-keyword-button';
        post_code_input_button.className = 'map-widget';
        post_code_input_button.innerHTML = "go"
        parent_container.appendChild(post_code_input_button);
        post_code_input_button.addEventListener('click', () => {
            let searchString = this._post_code_input.value;
            providerSearch.postcode(searchString).then((c: PostcodeSearchResponse) => {
                if (c.features[0] !== undefined) {
                    let center: [number, number] = c.features[0].geom.coordinates;
                    let x = [[center[0] - 0.01, center[1] - 0.01], [center[0] + 0.01, center[1] + 0.01]].map(v => ol.proj.transform(<[number, number]>v, 'EPSG:4326', 'EPSG:3857'));

                    globalMapObject.zoomTo([x[0][0], x[0][1], x[1][0], x[1][1]], {})
                    globalMapObject.flash_point(center, 2000);
                }
            })
        })





        this._domItems.push(this._post_code_input);
        this._domItems.push(post_code_input_button);
        this.mode('default').appendDomItem(this._post_code_input);
        this.mode('default').appendDomItem(post_code_input_button);
        if (USE_SELECT_BY_RECT) {
            this.mode('select-rectangle').appendDomItem(this._post_code_input);
            this.mode('select-rectangle').appendDomItem(post_code_input_button);
        }
        this.mode('select-polygon').appendDomItem(this._post_code_input);
        this.mode('select-polygon').appendDomItem(post_code_input_button);
        this.mode('select-file').appendDomItem(this._post_code_input);
        this.mode('select-file').appendDomItem(post_code_input_button);
        this.mode('file-selected').appendDomItem(this._post_code_input);
        this.mode('file-selected').appendDomItem(post_code_input_button);

        {
            this.createDomItem(parent_container, 'client-map-selector-file-curtain', { modeDomLink: ['select-file'], stateItem: true })
            let stateItem = this.createDomItem(parent_container, 'client-map-selector-file-container', { className: 'map-widget', modeDomLink: ['select-file'], stateItem: true })
            this.createDomItem(stateItem, 'client-map-selector-file-close', { modeToEnable: 'default' })
                .innerHTML = 'close';
            this.createDomItem(stateItem, 'client-map-selector-file-text', {})
                .innerHTML = 'drag file to open or click';
            let file_open_wrapper = this.createDomItem(stateItem, 'client-map-selector-file-open', {});
            geo_loader.init({
                drag_div: stateItem,
                open_div: { wrapper: file_open_wrapper, content: 'select-file', class: 'client-map-selector-file-open' },
                onload: (type: 'shp' | 'geojson' | 'kml', data: geo_loader.geoJsontype) => {
                    // ol.proj.get('EPSG:27700');
                    // proj4.defs("EPSG:27700","+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs");
                    // console.log(1);
                    let polygon = data.features.filter(f => f.geometry.type === 'Polygon')[0];
                    if (polygon !== undefined) {
                        let coordinates = <[number, number][][]>polygon.geometry.coordinates;
                        // console.log(coordinates)
                        coordinates[0] = coordinates[0].map(c => { console.log(c); return ol.proj.transform([c[0], c[1]], 'EPSG:4326', 'EPSG:3857') });

                        // console.log(coordinates);
                        // let ar = (new ol.geom.Polygon([coordinates_27700])).getArea();
                        // console.log('computeAreaFromCoordinates', computeAreaFromCoordinates(coordinates[0]))
                        // console.log('computeAreaFromCoordinates', computeAreaFromCoordinates(coordinates_27700))
                        // console.log(ar);
                        let f = new ol.Feature(new ol.geom.Polygon([coordinates[0]]));
                        f.setStyle(new ol.style.Style({
                            stroke: new ol.style.Stroke({ color: 'red' })
                        }));
                        this.mapSource.addFeature(f);
                        let extent = f.getGeometry().getExtent();
                        globalMapObject.zoomTo(extent, { factor: 2.1 })
                        this.setMode('file-selected');
                    }
                }
            });
        }

        {
            let stateItem = this.createDomItem(parent_container, 'client-map-selector', { className: 'map-widget', modeDomLink: ['default'], stateItem: true })


            let s = this
                .createDomItem(stateItem, 'client-map-selector-title', { className: 'client-map-selector-item' });
            s.innerHTML = 'select';
            s.title = 'Select Polygon to define report area on map or select file to upload a KML file ';

            if (USE_SELECT_BY_RECT)
                this
                    .createDomItem(stateItem, 'client-map-selector-rectangle', { className: 'client-map-selector-item', modeToEnable: 'select-rectangle' })
                    .innerHTML = 'rectangle';

            this
                .createDomItem(stateItem, 'client-map-selector-polygon', { className: 'client-map-selector-item', modeToEnable: 'select-polygon' })
                .innerHTML = 'Draw area';

            this
                .createDomItem(stateItem, 'client-map-selector-file', { className: 'client-map-selector-item', modeToEnable: 'select-file' })
                .innerHTML = 'File';
        }


        {
            let stateItem = this.createDomItem(parent_container, 'client-map-selector', { className: 'map-widget', modeDomLink: ['select-rectangle', 'select-polygon', 'file-selected'], stateItem: true })
            stateItem.style.height = '30px';

            this
                .createDomItem(stateItem, 'client-map-selector-cancel', { className: 'client-map-selector-item', modeToEnable: 'default' })
                .innerHTML = 'cancel';

            // this
            //     .createDomItem(stateItem, 'client-map-selector-proceed', { className: 'client-map-selector-item', stateChange: { sourceStateId: this.id, targetStateId: 'select-product' }, customToggleDomItem: { initialStatus: false } })
            //     .innerHTML = 'proceed';
        }

        {
            let stateItem = this.createDomItem(parent_container, 'select-navigate', { className: 'global-selector-navigate-container global-selector-navigate-container-bg', modeDomLink: ['default', 'select-rectangle', 'select-polygon', 'select-file', 'file-selected'], stateItem: true });
            let p = this.createDomItem(stateItem, 'select-previous', { className: 'global-selector-navigate' }); p.innerHTML = ' < back';
            let n = this.createDomItem(stateItem, 'select-next', { className: 'global-selector-navigate', stateChange: { sourceStateId: this.id, targetStateId: 'select-product' }, customToggleDomItem: { initialStatus: false } }); n.innerHTML = 'next > ';
            let n_dummy = this.createDomItem(stateItem, 'select-next-disabled', { className: 'global-selector-navigate', customToggleDomItem: { initialStatus: true } }); n_dummy.innerHTML = 'next > ';
        }

        {
            let stateItem = this.createDomItem(parent_container, 'select-area-notificator', { className: '', modeDomLink: ['select-rectangle', 'select-polygon', 'file-selected'], stateItem: true });
            let n = this.createDomItem(stateItem, 'select-area-notificator-content', { customToggleDomItem: { initialStatus: false } }); n.innerHTML = 'Thanks for selecting your report area, please press Next to continue';
        }


        this.setMode('default');
    }

    private get selectCoordinates(): number[][] {
        let f = this.mapSource.getFeatures();
        let coordinates: number[][] = [];
        if (f.length > 0) {
            let g: ol.geom.LineString = <any>this.mapSource.getFeatures()[0].getGeometry();
            coordinates = <any>g.getCoordinates()[0];
        }
        console.log(coordinates);
        return coordinates;
    }

    private get selectArea(): number {
        let transf = transformer("EPSG:3857", "EPSG:27700");
        let coordinates_27700 = this.selectCoordinates.map(c => { /*console.log(c);*/ return <[number, number]>transf([c[0], c[1]]) });
        let g2 = new ol.geom.Polygon([coordinates_27700]);
        // console.log(g2.getArea());
        return g2.getArea();;
    }


    private styleFunction(f: ol.Feature) {
        let geom = <any>f.getGeometry();

        if (this.isPoint(geom)) {
            let txt = "click to select (500ha max)";
            if (this.lastDrawRectangleGeomAreaValue === undefined) {
            } else {
                if (this.lastDrawRectangleGeomAreaValue > providerProduct.max_area) {
                    txt = "Requested area has exceeded the max " + (providerProduct.max_area / 10000).toFixed(0) + " ha";
                } else {
                    txt = (this.lastDrawRectangleGeomAreaValue / 10000).toFixed(0) + " ha";
                }
            }

            return new ol.style.Style({
                text: new ol.style.Text({
                    font: 'normal 13px Arial',
                    textAlign: 'left', text: txt, offsetX: 10, offsetY: -10,
                    stroke: new ol.style.Stroke({ color: 'white', width: 2 }),
                    fill: new ol.style.Fill({ color: 'black' })
                })
            });


        }
        if (this.isLineString(geom)) {
            if (this.lastDrawRectangleGeomAreaValue !== undefined && this.lastDrawRectangleGeomAreaValue > providerProduct.max_area) {
                return new ol.style.Style({
                    stroke: new ol.style.Stroke({ color: 'red' })
                });
            }
            return new ol.style.Style({
                stroke: new ol.style.Stroke({ color: 'rgba(20,200,100,0.8)' })
            });
        }
        if (this.isPolygon(geom)) {
            // this.lastDrawRectangleGeomAreaValue = geom.getArea();


            let coordinates = geom.getCoordinates();
            let transf = transformer("EPSG:3857", "EPSG:27700");
            let coordinates_27700 = coordinates[0].map(c => { /*console.log(c);*/ return <[number, number]>transf([c[0], c[1]]) });
            let g2 = new ol.geom.Polygon([coordinates_27700]);
            this.lastDrawRectangleGeomAreaValue = g2.getArea();

            if (this.lastDrawRectangleGeomAreaValue > providerProduct.max_area) {
                return new ol.style.Style({
                    fill: new ol.style.Fill({ color: 'rgba(255,50,50,0.3)' })
                });
            } else {
                return new ol.style.Style({
                    fill: new ol.style.Fill({ color: 'rgba(255,255,255,0.3)' })
                });
            }
        }
        console.log(f.getGeometry().getType);
    }

    private isPoint(geom: ol.geom.Point | ol.geom.LineString | ol.geom.Polygon): geom is ol.geom.Point {
        return geom.getType() === 'Point';
    }

    private isLineString(geom: ol.geom.Point | ol.geom.LineString | ol.geom.Polygon): geom is ol.geom.LineString {
        return geom.getType() === 'LineString';
    }

    private isPolygon(geom: ol.geom.Point | ol.geom.LineString | ol.geom.Polygon): geom is ol.geom.Polygon {
        return geom.getType() === 'Polygon';
    }


    public dispose() {
        super.dispose();
    }
}
